var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.764,
    height: 19.585,
    viewBox: "0 0 15.764 19.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-bin",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_445",
    "data-name": "Trazado 445",
    d: "M93.935,9.062c0-.377-.153-.5-.574-.5-.932,0-1.863,0-2.795,0h-.373c0-.5,0-.96,0-1.419s-.138-.589-.678-.589h-6.37c-1.026,0-1.026,0-1.026.915V8.56c-1.1,0-2.139,0-3.178,0-.394,0-.558.12-.562.452q-.016,1.542,0,3.084c0,.325.181.455.561.461.28,0,.561,0,.875,0,.01.108.02.173.022.239q.063,1.7.125,3.4.166,4.622.332,9.245c.013.35.167.495.553.495q5.314,0,10.627,0c.371,0,.531-.145.543-.474q.2-5.472.394-10.944c.023-.641.054-1.281.082-1.958.3,0,.576,0,.854,0,.415,0,.584-.136.587-.5Q93.947,10.561,93.935,9.062ZM83.057,7.389h6.2V8.543h-6.2Zm8.462,6.9c-.05,1.584-.116,3.167-.173,4.75-.07,1.939-.141,3.877-.2,5.816-.007.221-.1.27-.33.27q-4.662-.008-9.325,0c-.236,0-.319-.057-.326-.274-.059-1.862-.131-3.724-.2-5.586q-.112-3.2-.219-6.392c0-.094,0-.188,0-.3H91.522C91.522,13.165,91.537,13.729,91.519,14.293Zm1.5-2.575H79.306V9.381H93.017Z",
    transform: "translate(-78.371 -6.551)",
    fill: "#0050c4",
    stroke: "#0050c4",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_446",
    "data-name": "Trazado 446",
    d: "M246.281,209.493a.916.916,0,0,0-.071-.414.358.358,0,0,0-.337-.174.384.384,0,0,0-.3.192.875.875,0,0,0-.1.4q0,1.916,0,3.832,0,1.354,0,2.709c0,.432-.006.865,0,1.3a.4.4,0,0,0,.392.444c.244.007.4-.161.418-.449,0-.048,0-.1,0-.144Q246.282,213.34,246.281,209.493Z",
    transform: "translate(-238.091 -201.043)",
    fill: "#0050c4",
    stroke: "#0050c4",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_447",
    "data-name": "Trazado 447",
    d: "M309.8,208.369c-.257.055-.341.238-.347.49-.034,1.315-.076,2.63-.116,3.945h.008q-.045,1.469-.089,2.937c-.011.374-.022.749-.018,1.123a.363.363,0,0,0,.351.386.369.369,0,0,0,.433-.328,2.187,2.187,0,0,0,.028-.372q.053-1.9.1-3.8.05-1.944.094-3.888C310.253,208.529,310.057,208.314,309.8,208.369Z",
    transform: "translate(-299.029 -200.519)",
    fill: "#0050c4",
    stroke: "#0050c4",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_448",
    "data-name": "Trazado 448",
    d: "M177.625,213.756h.006c-.039-1.315-.075-2.631-.124-3.946a.62.62,0,0,0-.156-.4.335.335,0,0,0-.326-.047.446.446,0,0,0-.306.486q.1,3.889.2,7.777a1.153,1.153,0,0,0,.036.284.363.363,0,0,0,.409.286.373.373,0,0,0,.361-.348,1.592,1.592,0,0,0,0-.288Q177.679,215.657,177.625,213.756Z",
    transform: "translate(-172.37 -201.46)",
    fill: "#0050c4",
    stroke: "#0050c4",
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBin);
export default __webpack_public_path__ + "static/media/icon-bin.31ea79a500bd1b8ed1f9968237890c1a.svg";
export { ForwardRef as ReactComponent };